import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'selecionar-averbacao', pathMatch: 'full' },
  {
    path: 'selecionar-averbacao',
    loadChildren: () => import('./contrato-selecionar-averbacao/contrato-selecionar-averbacao.page.module').then(m => m.ContratoSelecionarAverbacaoPageModule)
  },
  {
    path: 'selecionar-forma-pagamento',
    loadChildren: () => import('./contrato-selecionar-forma-pagamento/contrato-selecionar-forma-pagamento.page.module').then(m => m.ContratoSelecionarFormaPagamentoPageModule)
  },
  {
    path: 'confirmar-super-social',
    loadChildren: () => import('./super-social/confirmar-solicitacao-super-social/confirmar-solicitacao-super-social.page.module').then(m => m.ConfirmarSolicitacaoSuperSocialPageModule)
  },
  {
    path: 'moradores-com-renda',
    loadChildren: () => import('./super-social/listagem-moradores-com-renda/listagem-moradores-com-renda.page.module').then(m => m.ListagemMoradoresComRendaPageModule)
  },
  {
    path: 'moradores-com-renda/adicionar',
    loadChildren: () => import('./super-social/moradores-com-renda-form/moradores-com-renda-form.page.module').then(m => m.MoradoresComRendaFormPageModule)
  },
  {
    path: 'moradores-com-renda/:cpf/editar',
    loadChildren: () => import('./super-social/moradores-com-renda-form/moradores-com-renda-form.page.module').then(m => m.MoradoresComRendaFormPageModule)
  },
  {
    path: 'comprovante-renda/selecionar-tipo-assinatura',
    loadChildren: () => import('./super-social/comprovante-renda-selecionar-tipo-assinatura/comprovante-renda-selecionar-tipo-assinatura.page.module').then(m => m.ComprovanteRendaSelecionarTipoAssinaturaPageModule)
  },
  {
    path: 'comprovante-renda/assinar',
    loadChildren: () => import('./super-social/comprovante-renda-assinatura/comprovante-renda-assinatura.page.module').then(m => m.ComprovanteRendaAssinaturaPageModule)
  },
  {
    path: 'comprovante-renda/upload',
    loadChildren: () => import('./super-social/comprovante-renda-upload/comprovante-renda-upload.page.module').then(m => m.ComprovanteRendaUploadPageModule)
  },
  {
    path: 'confirmar-informacoes',
    loadChildren: () => import('./contrato-confirmar-informacoes/contrato-confirmar-informacoes.page.module').then(m => m.ContratoConfirmarInformacoesPageModule)
  },
  {
    path: 'selecionar-tipo-assinatura',
    loadChildren: () => import('./contrato-selecionar-tipo-assinatura/contrato-selecionar-tipo-assinatura.module').then(m => m.ContratoSelecionarTipoAssinaturaPageModule)
  },
  {
    path: 'assinar',
    loadChildren: () => import('./contrato-assinatura/contrato-assinatura.module').then(m => m.ContratoAssinaturaPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContratoRoutingModule { }
